import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ata_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

let criticalHandler = null;
export const setCriticalHandler = (fn) => { criticalHandler = fn; };

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const { response, config } = error;
    if (response?.status === 428 && config && !config.__criticalRetried && criticalHandler) {
      config.__criticalRetried = true;
      try {
        let wrongOnce = false;
        while (true) {
          const pwd = await criticalHandler(wrongOnce);
          config.headers = { ...config.headers, "X-Critical-Password": pwd };
          try {
            return await api(config);
          } catch (e2) {
            const det = String(e2?.response?.data?.detail || "");
            if (e2?.response?.status === 403 && det.toLowerCase().includes("kritik")) { wrongOnce = true; continue; }
            throw e2;
          }
        }
      } catch {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export default api;
